import angular from 'angular';
import { MeurhAdmissoesOutrasinformacoesFormController } from './outrasinformacoes.form.controller';

export class MeurhAdmissoesOutrasinformacoesFormComponent implements angular.IComponentOptions {
	static selector = 'meurhAdmissoesOutrasinformacoesFormComponent';
	static controller = MeurhAdmissoesOutrasinformacoesFormController;
	static template = require('!!html-loader!./outrasinformacoes.form.html');
	static transclude = true;
	static bindings = {
		entity: '=',
		form: '<',
		busy: '=',
		action: '<',
	};
}
